import { NumericFormat } from 'react-number-format';
import './FormControls.css';
import PropTypes from 'prop-types';

const DecimalInput = ({
  name,
  handleChange,
  value,
  disabled,
  decimalScale,
  style,
  label,
  touched,
  setTouched,
  onBlur,
  errorMessage,
}) => {
  const handleClick = (event) => {
    event.target.select(); // Selektujemo tekst kada se klikne na input polje
  };
  return (
    <div>
      <div className="input_container">
        <label
          style={
            value?.length !== 0
              ? {
                  transform: 'translate(-15px, -7px) scale(0.8)',
                  backgroundColor: 'white',
                  padding: ' 0px 3px',
                }
              : {}
          }
        >
          {label}
        </label>
        <div style={{ display: 'grid' }}>
          <NumericFormat
            onValueChange={(e) => handleChange(e, name)}
            style={style}
            className={`input_text ${
              (touched && value?.length === 0) || value === undefined
                ? 'invalid'
                : ''
            }`}
            value={value}
            decimalSeparator="."
            onBlur={
              setTouched !== undefined
                ? () => setTouched(true)
                : onBlur !== undefined
                ? onBlur
                : () => {}
            }
            thousandSeparator={false}
            disabled={disabled}
            fixedDecimalScale
            decimalScale={decimalScale === undefined ? 2 : decimalScale}
            onClick={handleClick}
          />
        </div>
      </div>
      {touched && value?.length === 0 && (
        <span className="error-message">{errorMessage}</span>
      )}
    </div>
  );
};

export default DecimalInput;

DecimalInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
};
